import script from "./ProblemHandlingOrderDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProblemHandlingOrderDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ProblemHandlingOrderDialog.vue?vue&type=style&index=0&id=2628682c&lang=scss&scoped=true"
import "./ProblemHandlingOrderDialog.vue?vue&type=style&index=1&id=2628682c&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2628682c"]])

export default __exports__